import React from 'react'
import { CustomModal, InputText, InputCnpj } from '../../../../components'

const ModalEntregasParaRoteirizacaoDetalhes = ({ isVisible, onClose, entrega }) => {
  // Hooks
  const [selectedEntrega, setSelectedEntrega] = React.useState(undefined)
  React.useEffect(() => {
    setSelectedEntrega(entrega)
  }, [entrega])

  //Render
  return (
    <CustomModal header={'Detalhes da Entrega'} isVisible={isVisible} onClose={onClose} width={600}>
      <div className="p-grid">
        <div className="p-col-12">
          <InputText
            marginTop={0}
            disabled={true}
            label={'Status:'}
            value={selectedEntrega ? selectedEntrega.status : ''}
          />
        </div>
        <div className="p-col-4">
          <InputText
            marginTop={0}
            disabled={true}
            label={'Data Emissão:'}
            value={selectedEntrega ? selectedEntrega.dataEmissao : ''}
          />
        </div>
        <div className="p-col-4">
          <InputText
            marginTop={0}
            disabled={true}
            label={'Identificador:'}
            value={selectedEntrega ? selectedEntrega.identifier : ''}
          />
        </div>
        <div className="p-col-4">
          <InputText
            marginTop={0}
            disabled={true}
            label={'Lote Carregamento:'}
            value={selectedEntrega ? selectedEntrega.loteCarregamento : ''}
          />
        </div>
        <div className="p-col-8">
          <InputText
            marginTop={0}
            disabled={true}
            label={'Fantasia:'}
            value={selectedEntrega ? selectedEntrega.nomeFantasia : ''}
          />
        </div>
        <div className="p-col-4">
          <InputCnpj
            marginTop={0}
            value={selectedEntrega ? selectedEntrega.cnpj_cliente : ''}
            label={'CNPJ'}
            disabled={true}
            onChange={() => {}}
          />
        </div>
        <div className="p-col-6">
          <InputText
            marginTop={0}
            disabled={true}
            label={'Cidade:'}
            value={selectedEntrega ? selectedEntrega.city : ''}
          />
        </div>
        <div className="p-col-2">
          <InputText
            marginTop={0}
            disabled={true}
            label={'Qte Caixas:'}
            value={selectedEntrega ? selectedEntrega.qteSkuTotal : ''}
          />
        </div>
        <div className="p-col-2">
          <InputText
            marginTop={0}
            disabled={true}
            label={'Peso:'}
            value={selectedEntrega ? selectedEntrega.weightTotal : ''}
          />
        </div>
        <div className="p-col-2">
          <InputText
            marginTop={0}
            disabled={true}
            label={'Volume:'}
            value={selectedEntrega ? selectedEntrega.volumeM3 : ''}
          />
        </div>
      </div>
    </CustomModal>
  )
}

export default ModalEntregasParaRoteirizacaoDetalhes
